import { render, staticRenderFns } from "./PrintHome.vue?vue&type=template&id=36adf65e&scoped=true&"
import script from "./PrintHome.vue?vue&type=script&lang=js&"
export * from "./PrintHome.vue?vue&type=script&lang=js&"
import style0 from "./PrintHome.vue?vue&type=style&index=0&id=36adf65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36adf65e",
  null
  
)

export default component.exports